import { CertificationInstance, ReportInstance } from "@/instance/axios";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  CertificationApiCertificationEnergySavingGetRequest,
  CertificationApiCertificationPredictionAccuracyGetRequest,
  CertificationApiCertificationSourceGetRequest,
  CertificationApiCertificationStatisticsGetRequest,
} from "@sizlcorp/sizl-fems-api-document/dist/models/src/api/certification-api";
import { ReportApiCertificationAnomalyCountGetRequest } from "@sizlcorp/sizl-fems-api-document/dist/models/src/api/report-api";

export const certifications = createQueryKeys("certifications", {
  all: null,
  getCertification: (params: CertificationApiCertificationEnergySavingGetRequest) => {
    return {
      queryKey: ["getCertification"],
      queryFn: () => CertificationInstance.certificationEnergySavingGet(params),
    };
  },
  getPredictionAccuracy: (params: CertificationApiCertificationPredictionAccuracyGetRequest) => {
    return {
      queryKey: ["getPredictionAccuracy", params],
      queryFn: () => CertificationInstance.certificationPredictionAccuracyGet(params),
    };
  },
  getSource: (params: CertificationApiCertificationSourceGetRequest) => {
    return {
      queryKey: ["getSource", params],
      queryFn: () => CertificationInstance.certificationSourceGet(params),
    };
  },
  getStatistics: (params: CertificationApiCertificationStatisticsGetRequest) => {
    return {
      queryKey: ["getStatistics", params],
      queryFn: () => CertificationInstance.certificationStatisticsGet(params),
    };
  },
  getAnomalyCount: (params: ReportApiCertificationAnomalyCountGetRequest) => {
    return {
      queryKey: ["getanomalyCount", params],
      queryFn: () => ReportInstance.certificationAnomalyCountGet(params),
    };
  },
  peakReductionRate: () => {
    return {
      queryKey: ["peakReductionRate"],
      queryFn: () => ReportInstance.certificationPeakReductionRateGet(),
    };
  },
});
